import { getTranslate, TranslateFunction } from 'react-localize-redux';
import { Action, AnyAction } from 'redux';
// tslint:disable-next-line:no-submodule-imports
import { ActionPattern, call, Effect, put, putResolve, select, takeEvery } from 'redux-saga/effects';
import { showAlert, showTransientAlert } from './alerts/actionCreators';
import { endLoading, startLoading } from './navigation/actionCreators';
import { RootState } from './store';

export function takeEveryWithErrorHandling<A extends Action>(
    pattern: ActionPattern<A>,
    // tslint:disable-next-line:no-any
    saga: (action: A) => any,
    onErrorSaga?: (error: Error, action: A) => IterableIterator<Effect>
) {
    return takeEvery(pattern, function*(action: A) {
        yield put(startLoading());
        try {
            yield* saga(action);
        } catch (error) {
            if (error.error) {
                error = error.error;
            }
            if (error.response) {
                error = JSON.parse(error.response).error;
            }
            if (error.json && error.json.error) {
                error = error.json.error;
            }
            if (onErrorSaga) {
                yield* onErrorSaga(error, action);
            } else {
                yield put(
                    showAlert({
                        color: 'danger',
                        // tslint:disable-next-line:no-any
                        message: error,
                        title: 'Error',
                        type: 'error'
                    })
                );
            }
        } finally {
            yield put(endLoading());
        }
    });
}